var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-table-rows px-8 mb-3"},[_c('loader-text',{attrs:{"lines":_vm.rows,"line-width":"100%","thickness":4,"line-class":"my-2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }